const model = {
    _id: '',
    id: '',
    createdAt: '',
    updatedAt: '',
    prelim_universal: false,
    prelim_selective: false,
    prelim_selective_one: false,
    prelim_selective_two: false,
    prelim_selective_three: false,
    prelim_selective_four: false,
    prelim_selective_five: false,
    prelim_selective_six: false,
    prelim_selective_seven: false,
    prelim_noprotocol: false,
    prelim_other: false,
    prelim_other_text: '',
    e_fl_low_wage: false,
    e_fl_long_hours: false,
    e_fl_dangerous_condition: false,
    e_fl_tricked: false,
    e_fl_unable_to_quit: false,
    e_fl_against_will: false,
    e_fl_otherText: '',
    e_db_in_debt: false,
    e_db_work_in_exchange: false,
    e_db_debt_increasing: false,
    e_db_debt_uncertain: false,
    e_db_otherText: '',
    m_c_legal: false,
    m_c_documents: false,
    m_c_isolated: false,
    m_c_control: false,
    m_c_surveilance: false,
    m_c_abuse: false,
    m_c_violence: false,
    m_c_retaliation: false,
    m_c_otherText: '',
    m_fr_documents: false,
    m_fr_job_condition: false,
    m_fr_opportunity: false,
    m_fr_otherText: '',
    m_fo_harm: false,
    m_fo_substance: false,
    m_fo_sexual_abuse: false,
    m_fo_restraint: false,
    m_fo_denied_care: false,
    m_fo_otherText: '',
    p_third_party: false,
    p_transport: false,
    p_housing: false,
    p_benefit: false,
    p_recruit: false,
    p_harboring: false,
    p_restrained: false,
    p_otherText: '',
    conclusion: '',
    person: '',
    createdBy: '',
    updatedBy: '',
    organizationCreator: '',
    organizationOwner: '',
    location: '',
    program: ''
}

export { model }



// WEBPACK FOOTER //
// ./src/api/models/laborScreening.js